<div class="header flex items-center">
  <app-player-row
    (click)="
      isMenuless(coinflipSide())
        ? null
        : contextMenuService.open($event, { user: coinflipSide() })
    "
    [player]="coinflipSide()"
  ></app-player-row>
  <div class="skins-price">
    Skins price:
    <app-balance-icon [balance]="coinflipGame().is_pure ? 'pure' : 'skins'" />
    {{ skinsPrice() | number : "1.2-2" }}
  </div>
  <div
    class="gameid"
    (click)="
      clipboardService.copy(coinflipGame().gameid, 'GameID copied to clipboard')
    "
  >
    GameID:
    {{ coinflipGame().gameid }}
  </div>
</div>
<div class="divider horizontal w-full"></div>
<div class="skins">
  <app-skins-list
    [skins]="skins()"
    [selectable]="false"
    [balanceType]="coinflipGame().is_pure ? 'pure' : 'skins'"
    [config]="{ mobile: { skin_min_width: '130px' } }"
  />
</div>
